export default "__VITE_PUBLIC_ASSET__f5fa6b42__"